// extracted by mini-css-extract-plugin
export default {"layout":"Home_layout__YDTXE","image":"Home_image__7mGhJ"};